"use client"
/* */
const generateTranslationString = (rule, shortVersion = false) => {
  if (rule.translationKey) {
    return `validation.${rule.translationKey}`;
  }
  const translateString = `validation.${rule.ruleType ?? "general"}`;
  let finalTranslationString = "";
  if ("min" in rule || "max" in rule) {
    const breakingBoundaryProperty = rule.failingBoundary ? rule.failingBoundary : "min";
    if (rule.identifier) {
      finalTranslationString = `${translateString}.${rule.identifier}.${breakingBoundaryProperty}`;
    } else {
      finalTranslationString = `${translateString}.${breakingBoundaryProperty}`;
    }
  } else if (rule.identifier) {
    finalTranslationString = `${translateString}.${rule.identifier}`;
  } else {
    finalTranslationString = translateString;
  }
  return shortVersion ? `${finalTranslationString}.short` : finalTranslationString;
};
const generateValidationTranslation = (r, shotVersion = false) => {
  const translationKey = generateTranslationString(r, shotVersion);
  return [
    translationKey,
    r
  ];
};

export { generateValidationTranslation as default, generateValidationTranslation };
//# sourceMappingURL=generateValidationTranslation.mjs.map
